import { useEffect, useState } from "react"
import { useAppSelector } from "./redux/hooks"

const useIsCrossChain = () => {
    const { fromToken, fromChain, toChain, toToken } = useAppSelector((state) => state.coreInfo)
    const [ isCrossChain, setIsCrossChain ] = useState(true)
    const [ aggregateType, setAggregateType ] = useState('swap')
    
    useEffect(() => {
        if(fromToken && fromChain && toChain && toToken) {
            if(fromToken?.symbol === toToken?.symbol && fromChain?.nickName !== toChain?.nickName) {
                setIsCrossChain(true)
            } else {
                setIsCrossChain(false)
                if(fromToken?.symbol !== toToken?.symbol && fromChain?.nickName === toChain?.nickName) {
                    setAggregateType('swap')
                } else {
                    setAggregateType('noswap')
                }
            }
        }
    }, [fromToken, fromChain, toChain, toToken])

    return { isCrossChain, aggregateType }
}

export default useIsCrossChain